import { isPlatformBrowser, NgClass, CurrencyPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';

//* Material
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

//* Components
import { DeleteMissingProductsModalComponent } from '@components/delete-missing-products-modal/delete-missing-products-modal.component';
import { DeliveryComponent } from '@components/delivery/delivery.component';

//* RXJS
import { AppStateCart } from 'src/app/state/cart/cart.reducer';
import { Store } from '@ngrx/store';
import * as cart from '../../../state/cart/cart.actions';
import * as user from '../../../state/user/user.actions';
import { AppStateUser } from 'src/app/state/user/user.reducer';
import { Subject, takeUntil } from 'rxjs';

//* Models
import { Item } from '@models/cart.model';
import { IModal } from '@models/modal.model';

//* Services
import { SnackbarService } from '@services/snackbar.service';
import { StoreService } from '@services/stores.service';
import { AddressObserverService } from '@services/address-observer.service';
import { CartObserverService } from '@services/cart-observer.service';
import { CartService } from '@services/cart.service';
import { LocalstorageService } from '@services/localstorage.service';
import { ProductsValidationsService } from '@services/products-validations.service';

//* Shared
import { VALIDATION_DATA } from '@shared/utils';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { ProductCartComponent } from '../product-cart/product-cart.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StoreData } from '@models/store.model';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  standalone: true,
  imports: [NgClass, MatFormFieldModule, MatIconModule, MatDialogModule, MatProgressSpinnerModule, ProductCartComponent, MatButtonModule, CurrencyPipe, TranslateModule]
})

export class CartComponent implements OnInit, OnDestroy {

  public shipping = 0;
  public cartList: any[];
  public totalToPay: number;
  public totalProducts = 0;
  private subs = new Subject<void>();
  public splitCartData: any;
  public loadProducts = true;
  public blockedUser = false;

  private validationData: IModal = VALIDATION_DATA;

  private plaformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.plaformId);

  constructor(
    private router: Router,
    private cartService: CartService,
    private cartObserver: CartObserverService,
    private dialog: MatDialog,
    private addressObserver: AddressObserverService,
    private storeService: StoreService,
    private snackbarService: SnackbarService,
    private store: Store<AppStateCart>,
    private storeUser: Store<AppStateUser>,
    private localStorageService: LocalstorageService,
    private productsValidationsService: ProductsValidationsService,
    private storeCart: Store<AppStateCart>

  ) { }

  async ngOnInit(): Promise<void> {
    //  await this.verifyCart();
    this.getCartList();
    this.cartObserver.dataUser.pipe(takeUntil(this.subs)).subscribe((itemsCounter: number) => this.totalProducts = itemsCounter);
    this.setLocalCartListener();

  }


  public setLocalCartListener(): void {

    this.storeCart.select('cart').pipe(takeUntil(this.subs)).subscribe(async ({ info }) => {
      if (info) {
        try {
          await this.verifyCart();
          this.totalToPay = 0.0;
          this.shipping = info?.shipping;
          this.totalToPay = info?.total;
          const auxList = info?.items.map((item: any) => {
            let exist = true;
            if (this.splitCartData?.items?.length > 0) {
              this.splitCartData?.items?.forEach((item2: any) => {
                if (item.item_id === item2.sku) {
                  exist = false;
                  return;
                }
              });
            }
            return {
              ...item,
              existInBranch: exist,
            };
          });
          this.cartList = auxList;
          if (this.totalProducts === 0 && this.cartList.length > 0) {
            this.totalProducts = this.productsValidationsService.setCartCounter(this.cartList);
          }
          const tempItems = info.items.map((item: Item) => ({ ...item }));
          this.localStorageService.setProperty('cartItems', tempItems);
          this.loadProducts = false;
        } catch (error) {
        }
      }
    });
  }



  public async verifyCart(): Promise<void> {
    try {
      const { data } = await this.cartService.verifyProductsOnSelectedBranch();
      this.splitCartData = data;
    } catch (error: any) {
      switch (error?.error?.data?.error) {
        case 'User blocked':
          this.blockedUser = true;
          break;
        case 'Type delivery o pickup are unavailable on this branch':
          this.snackbarService.openDialog(this.validationData, {
            width: '500px',
            autoFocus: false
          });
          break;
      }
      if (error?.error?.data?.error === 'User blocked') {
        this.blockedUser = true;
      }
      if (error?.status === 404) {
        this.snackbarService.openSnackbar('GENERAL.stockError', 'warn');
      }
    }
  }

  public async onNavigate(route: string): Promise<void> {
    if (!this.blockedUser) {
      if (route === '/carrito/sugerencias') {
        try {
          const res: boolean = await this.getStoreByIdAndCheckType();
          if (res) {
            if (this.isBrowser) {
              const shippingType = JSON.parse(localStorage.getItem('address') || '{}').type;
              if (shippingType === 'delivery' || shippingType === 'pickup') {
                switch (this.splitCartData.message) {
                  case 'Items ok.':
                    if (res) {
                      await this.router.navigate([route]);
                      if (this.isBrowser) window.scroll(0, 0);
                    }
                    break;
                  default:
                    this.openDeleteMissingProducts(this.splitCartData);
                    break;
                }
              } else {
                this.dialog.open(DeliveryComponent, {
                  panelClass: 'as-delivery-dialog'
                }).afterClosed().subscribe(response => {
                  if (response.status) {
                    this.onEmitDisplay(response);
                  }
                });
              }
            }
          } else {
            this.dialog.open(DeliveryComponent, {
              panelClass: 'as-delivery-dialog'
            }).afterClosed().subscribe(response => {
              if (response.status) {
                this.onEmitDisplay(response);
              }
            });
          }
        } catch (error) {
        }
      } else {
        await this.router.navigate([route]);
        if (this.isBrowser) window.scroll(0, 0);
      }
    } else {
      try {
        if (this.isBrowser) localStorage.clear();
        this.store.dispatch(cart.unSetCart());
        this.storeUser.dispatch(user.unSetUser());
        this.snackbarService.openSnackbar('GENERAL.userBlocked', 'warn');
        await this.router.navigate(['autenticacion/iniciar-sesion']);
        if (this.isBrowser) window.location.reload();
      } catch (error: any) { }
    }
  }

  public async getStoreByIdAndCheckType(): Promise<boolean> {
    try {
      if (this.isBrowser) {
        const storeLocal = JSON.parse(localStorage.getItem('address') || '{}');
        const { data } = await this.storeService.getStore(storeLocal.store);
        const store: StoreData = data;
        if ((storeLocal.type === 'delivery' && store.accept_delivery) || (storeLocal.type === 'pickup' && store.accept_pickup)) {
          return true;
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  public onEmitDisplay(response: any): void {
    this.addressObserver.address$.emit(response);
  }

  public openDeleteMissingProducts(res: any): void {
    this.dialog.open(DeleteMissingProductsModalComponent, {
      data: { res, cart: this.cartList }
    });
  }

  public async getCartList(): Promise<void> {
    this.totalToPay = 0.0;
    this.cartService.onGettingCartList().subscribe(({
      next: ({ data }) => {
        this.shipping = data.shipping;
        this.totalToPay = data.total;
        this.cartList = data.items;
        this.cartList.forEach((item: any) => {
          item.existInBranch = true;
          if (this.splitCartData?.items?.length > 0) {
            this.splitCartData?.items?.forEach((item2: any) => {
              if (item.item_id === item2.sku) {
                item.existInBranch = false;
              }
            });
          }
        });
        if (this.totalProducts === 0 && this.cartList.length > 0) {
          this.totalProducts = this.productsValidationsService.setCartCounter(this.cartList);
        }
        const tempItems = data.items.map((item: Item) => ({ ...item }));
        this.localStorageService.setProperty('cartItems', tempItems);
        this.loadProducts = false;
      },
      error: (error) => {
        this.loadProducts = false;
      }
    }));
  }


  public getFloatDecimalPortion(x: any) {
    x = Math.abs(parseFloat(x));
    const n = parseInt(x);
    return Number((x - n).toFixed(Math.abs(('' + x).length - ('' + n).length - 1)));
  }

  public onAddingProduct(event: any): void {
    this.totalToPay += event;
  }

  public onSubtractingProduct(event: any): void {
    this.totalToPay -= event.price;
  }

  public onSetProduct(event: any): void {
    this.totalToPay -= event.total_price;
    this.totalToPay += event.new_price;
  }

  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
  }
}
